/**
 * Common system objects by connector/system type
 * Maps system names to their commonly used objects with optional hints
 */
export const SYSTEM_OBJECT_SUGGESTIONS = {
  'ApexTrading': [
    { object: 'products', hint: '' },
    { object: 'orders', hint: '' },
    { object: 'shipping-order', hint: '' },
    { object: 'shipping-order-items', hint: 'Use ItemsLineDataSetPointer from shipping-order in the filter to retrieve line items' },
    { object: 'shipping-order-sales-reps', hint: 'Use SalesRepsLineDataSetPointer from shipping-order in the filter to retrieve sales reps' },
    { object: 'buyers', hint: '' },
    { object: 'buyer', hint: 'Use id = {buyer_id} as the filter (e.g., id = 96156). Returns buyer data with optional LineDataSetPointers for locations and contacts' },
    { object: 'buyer-locations', hint: 'Use LocationsLineDataSetPointer from buyer in the filter to retrieve location records' },
    { object: 'buyer-contacts', hint: 'Use ContactsLineDataSetPointer from buyer in the filter to retrieve contact records' },
  ],
  'Adaptive': [
    { object: 'ImportStandardData', hint: '' },
    { object: 'ImportCubeData', hint: '' },
    { object: 'ImportConfigurableModelData', hint: '' },
    { object: 'ImportTransactions', hint: '' },
    { object: 'EraseActuals', hint: '' },
  ],
  'Amazon S3': [
    { object: 'Bucket', hint: 'Filter: (Optional) Prefix path, e.g., folder/subfolder/. Child ID Filter: (Optional) Wildcard pattern, e.g., *.csv' },
    { object: 'Object', hint: 'Filter: S3 object key (path to file). Examples: reports/monthly-report.csv, data/exports/customers-[yyyy-MM-dd].json, backups/database-[yyyyMMdd].sql' },
  ],
  'Anaplan': [
    { object: 'UploadFile', hint: '' },
    { object: 'Complete', hint: '' },
    { object: 'Start', hint: '' },
  ],
  'Bill.com': [
    { object: 'Attachment', hint: '' },
    { object: 'Note', hint: '' },
    { object: 'Bill', hint: '' },
    { object: 'PaymentTerms_List', hint: '' },
    { object: 'Department_List', hint: '' },
    { object: 'Location_List', hint: '' },
    { object: 'ChartOfAccount_List', hint: '' },
    { object: 'Job_List', hint: '' },
    { object: 'PaymentTerm', hint: '' },
    { object: 'Department', hint: '' },
    { object: 'Location', hint: '' },
    { object: 'ChartOfAccount', hint: '' },
    { object: 'Job', hint: '' },
    { object: 'BillPay_List', hint: '' },
    { object: 'Bill_List', hint: '' },
    { object: 'Vendor_List', hint: '' },
  ],
  'Concur': [
    { object: 'Vendor', hint: '' },
    { object: 'VendorBank', hint: '' },
    { object: 'Attachment', hint: '' },
    { object: 'Header', hint: '' },
    { object: 'Lines', hint: '' },
  ],
  'Coupa': [
    { object: 'attachment', hint: '' },
    { object: 'coupapaypayments', hint: '' },
    { object: 'expense', hint: '' },
    { object: 'expenseArtifact', hint: '' },
    { object: 'expenseLineAccountAllocations', hint: 'Use LineDataSetPointer of Expense Header in the filter and line ID in the condition' },
    { object: 'expenseLineArtifacts', hint: '' },
    { object: 'expenselines', hint: 'Use LineDataSetPointer of Expense Header in the filter' },
    { object: 'invoiceattachments', hint: '' },
    { object: 'invoiceLineAccountAllocations', hint: 'Use LineDataSetPointer of InvoiceHeader in the filter and line ID in the condition' },
    { object: 'invoiceLines', hint: 'Use LineDataSetPointer of InvoiceHeader in the filter' },
    { object: 'invoices', hint: '' },
    { object: 'invoiceCharges', hint: 'Use LineDataSetPointer of InvoiceHeader in the filter and line ID in the condition' },
    { object: 'taxLines', hint: 'Use LineDataSetPointer of InvoiceHeader in the filter and line ID in the condition' },
    { object: 'lookupvalue', hint: '' },
    { object: 'paymentdetailpayableallocations', hint: '' },
    { object: 'paymentdetails', hint: '' },
    { object: 'supplier', hint: '' },
  ],
  'Masttro': [
    { object: 'Clients', hint: 'Get all clients' },
    { object: 'ClosedEndFunds', hint: 'Get closed-end fund data' },
    { object: 'DataFeedUpdate', hint: 'Get data feed update status' },
    { object: 'Documents', hint: 'Get document content' },
    { object: 'GWM', hint: 'Get Global Wealth Management data' },
    { object: 'Holdings', hint: 'Get holdings for a client' },
    { object: 'Performance', hint: 'Get performance metrics' },
    { object: 'Transactions', hint: 'Get transactions' },
    { object: 'TaxLot/UnrealizedGL', hint: 'Get unrealized gains/losses' },
    { object: 'TaxLot/RealizedGL', hint: 'Get realized gains/losses' },
    { object: 'PublishedReports', hint: 'Get published reports' },
  ],
  'Rev.IO': [
    { object: 'Bills', hint: '' },
    { object: 'Charges', hint: '' },
    { object: 'Customers', hint: '' },
    { object: 'Contacts', hint: '' },
    { object: 'Payments', hint: '' },
  ],
  'SFTP': [
    { object: 'File', hint: '' },
    { object: 'MoveFile', hint: '' },
    { object: 'Directory', hint: '' },
  ],
  'Tessitura': [
    { object: 'CustomExecute', hint: '' },
    { object: 'CustomExecuteLines', hint: 'Referenced using the linedatasetpointer pattern in the filter. Note: transactions are grouped by transaction_no. Filter: linedatasetpointer = {{<step id of the foreach that iterates the CustomExecute query results>_LineDataSetPointer}}' },
    { object: 'Plans', hint: '' },
    { object: 'GetConstituentById', hint: '' },
    { object: 'Address', hint: '' },
  ],
  'Salesforce': [
    { object: 'Account', hint: '' },
    { object: 'Contact', hint: '' },
    { object: 'Lead', hint: '' },
    { object: 'Opportunity', hint: '' },
    { object: 'Quote', hint: '' },
    { object: 'Contract', hint: '' },
    { object: 'Case', hint: '' },
    { object: 'Task', hint: '' },
    { object: 'Event', hint: '' },
    { object: 'Product2', hint: '' },
    { object: 'PricebookEntry', hint: '' },
    { object: 'OpportunityLineItem', hint: '' },
    { object: 'User', hint: '' },
    { object: 'Profile', hint: '' },
    { object: 'RecordType', hint: '' },
    { object: 'Campaign', hint: '' },
    { object: 'Order', hint: '' },
    { object: 'Asset', hint: '' },
  ],
  'Intacct': [
    { object: 'GLENTRY', hint: '' },
    { object: 'GLDETAIL', hint: '' },
    { object: 'GLACCOUNT', hint: '' },
    { object: 'GLBATCH', hint: '' },
    { object: 'CUSTOMER', hint: '' },
    { object: 'ARINVOICE', hint: '' },
    { object: 'ARPAYMENT', hint: '' },
    { object: 'VENDOR', hint: '' },
    { object: 'APBILL', hint: '' },
    { object: 'APPAYMENT', hint: '' },
    { object: 'PURCHASEORDER', hint: '' },
    { object: 'PODOCUMENT', hint: '' },
    { object: 'SODOCUMENT', hint: '' },
    { object: 'CHECKINGACCOUNT', hint: '' },
    { object: 'DEPOSITENTRY', hint: '' },
    { object: 'PROJECT', hint: '' },
    { object: 'DEPARTMENT', hint: '' },
    { object: 'LOCATION', hint: '' },
    { object: 'CLASS', hint: '' },
    { object: 'EMPLOYEE', hint: '' },
    { object: 'CONTACT', hint: '' },
    { object: 'ITEM', hint: '' },
    { object: 'CONTRACT', hint: '' },
  ],
  'NetSuite': [
    { object: 'Customer', hint: '' },
    { object: 'Vendor', hint: '' },
    { object: 'Employee', hint: '' },
    { object: 'Contact', hint: '' },
    { object: 'Partner', hint: '' },
    { object: 'Lead', hint: '' },
    { object: 'Prospect', hint: '' },
    { object: 'Opportunity', hint: '' },
    { object: 'SalesOrder', hint: '' },
    { object: 'Invoice', hint: '' },
    { object: 'CashSale', hint: '' },
    { object: 'CreditMemo', hint: '' },
    { object: 'CustomerPayment', hint: '' },
    { object: 'Estimate', hint: '' },
    { object: 'PurchaseOrder', hint: '' },
    { object: 'VendorBill', hint: '' },
    { object: 'VendorPayment', hint: '' },
    { object: 'VendorCredit', hint: '' },
    { object: 'Item', hint: '' },
    { object: 'InventoryItem', hint: '' },
    { object: 'ServiceItem', hint: '' },
    { object: 'NonInventoryItem', hint: '' },
    { object: 'AssemblyItem', hint: '' },
    { object: 'Account', hint: '' },
    { object: 'Transaction', hint: '' },
    { object: 'JournalEntry', hint: '' },
    { object: 'GeneralLedger', hint: '' },
    { object: 'Department', hint: '' },
    { object: 'Location', hint: '' },
    { object: 'Classification', hint: '' },
    { object: 'Subsidiary', hint: '' },
    { object: 'Currency', hint: '' },
    { object: 'Project', hint: '' },
    { object: 'Task', hint: '' },
    { object: 'TimeEntry', hint: '' },
    { object: 'ExpenseReport', hint: '' },
    { object: 'BinTransfer', hint: '' },
    { object: 'InventoryAdjustment', hint: '' },
    { object: 'ItemFulfillment', hint: '' },
    { object: 'ItemReceipt', hint: '' },
    { object: 'ReturnAuthorization', hint: '' },
    { object: 'CashRefund', hint: '' },
    { object: 'DepositApplication', hint: '' },
    { object: 'Deposit', hint: '' },
  ],
  'Business Central': [
    { object: 'Customer', hint: '' },
    { object: 'Vendor', hint: '' },
    { object: 'Employee', hint: '' },
    { object: 'Contact', hint: '' },
    { object: 'Item', hint: '' },
    { object: 'SalesOrder', hint: '' },
    { object: 'SalesInvoice', hint: '' },
    { object: 'SalesCreditMemo', hint: '' },
    { object: 'SalesQuote', hint: '' },
    { object: 'PurchaseOrder', hint: '' },
    { object: 'PurchaseInvoice', hint: '' },
    { object: 'PurchaseCreditMemo', hint: '' },
    { object: 'GeneralLedgerEntry', hint: '' },
    { object: 'GLAccount', hint: '' },
    { object: 'JournalLine', hint: '' },
    { object: 'CustomerLedgerEntry', hint: '' },
    { object: 'VendorLedgerEntry', hint: '' },
    { object: 'ItemLedgerEntry', hint: '' },
    { object: 'BankAccount', hint: '' },
    { object: 'BankAccountLedgerEntry', hint: '' },
    { object: 'PaymentMethod', hint: '' },
    { object: 'Currency', hint: '' },
    { object: 'Dimension', hint: '' },
    { object: 'DimensionValue', hint: '' },
    { object: 'Location', hint: '' },
    { object: 'Warehouse', hint: '' },
    { object: 'InventoryPostingGroup', hint: '' },
    { object: 'CustomerPostingGroup', hint: '' },
    { object: 'VendorPostingGroup', hint: '' },
    { object: 'FixedAsset', hint: '' },
    { object: 'Resource', hint: '' },
    { object: 'Job', hint: '' },
    { object: 'JobTask', hint: '' },
    { object: 'JobLedgerEntry', hint: '' },
    { object: 'TimeSheetHeader', hint: '' },
    { object: 'TimeSheetLine', hint: '' },
    { object: 'SalesShipment', hint: '' },
    { object: 'PurchaseReceipt', hint: '' },
    { object: 'TransferOrder', hint: '' },
    { object: 'Assembly', hint: '' },
    { object: 'ProductionOrder', hint: '' },
    { object: 'CountryRegion', hint: '' },
    { object: 'PaymentTerms', hint: '' },
    { object: 'ShippingAgent', hint: '' },
    { object: 'UnitOfMeasure', hint: '' },
  ],
  'Customer Engagement': [
    { object: 'Account', hint: '' },
    { object: 'Contact', hint: '' },
    { object: 'Lead', hint: '' },
    { object: 'Opportunity', hint: '' },
    { object: 'Quote', hint: '' },
    { object: 'Order', hint: '' },
    { object: 'Invoice', hint: '' },
    { object: 'Case', hint: '' },
    { object: 'Activity', hint: '' },
    { object: 'Task', hint: '' },
    { object: 'Appointment', hint: '' },
    { object: 'PhoneCall', hint: '' },
    { object: 'Email', hint: '' },
    { object: 'Note', hint: '' },
    { object: 'Product', hint: '' },
    { object: 'PriceLevel', hint: '' },
    { object: 'PriceListItem', hint: '' },
    { object: 'OpportunityProduct', hint: '' },
    { object: 'QuoteDetail', hint: '' },
    { object: 'OrderDetail', hint: '' },
    { object: 'InvoiceDetail', hint: '' },
    { object: 'Campaign', hint: '' },
    { object: 'CampaignActivity', hint: '' },
    { object: 'CampaignResponse', hint: '' },
    { object: 'MarketingList', hint: '' },
    { object: 'Competitor', hint: '' },
    { object: 'Contract', hint: '' },
    { object: 'ContractDetail', hint: '' },
    { object: 'Entitlement', hint: '' },
    { object: 'KnowledgeArticle', hint: '' },
    { object: 'Queue', hint: '' },
    { object: 'QueueItem', hint: '' },
    { object: 'Team', hint: '' },
    { object: 'User', hint: '' },
    { object: 'SystemUser', hint: '' },
    { object: 'BusinessUnit', hint: '' },
    { object: 'Organization', hint: '' },
    { object: 'Territory', hint: '' },
    { object: 'Goal', hint: '' },
    { object: 'Metric', hint: '' },
    { object: 'Connection', hint: '' },
    { object: 'Annotation', hint: '' },
    { object: 'Attachment', hint: '' },
    { object: 'SLA', hint: '' },
    { object: 'SLAItem', hint: '' },
    { object: 'Workflow', hint: '' },
    { object: 'CustomEntity', hint: '' },
    { object: 'TransactionCurrency', hint: '' },
    { object: 'Discount', hint: '' },
    { object: 'DiscountList', hint: '' },
    { object: 'Subject', hint: '' },
    { object: 'IncidentResolution', hint: '' },
    { object: 'ServiceAppointment', hint: '' },
    { object: 'Resource', hint: '' },
    { object: 'ResourceGroup', hint: '' },
    { object: 'BookableResource', hint: '' },
    { object: 'BookableResourceBooking', hint: '' },
  ],
  'D365 FSC': [
    { object: 'CustTable', hint: '' },
    { object: 'VendTable', hint: '' },
    { object: 'HcmWorker', hint: '' },
    { object: 'DirPartyTable', hint: '' },
    { object: 'ContactPerson', hint: '' },
    { object: 'InventTable', hint: '' },
    { object: 'SalesTable', hint: '' },
    { object: 'SalesLine', hint: '' },
    { object: 'CustInvoiceJour', hint: '' },
    { object: 'CustInvoiceTrans', hint: '' },
    { object: 'CustTrans', hint: '' },
    { object: 'PurchTable', hint: '' },
    { object: 'PurchLine', hint: '' },
    { object: 'VendInvoiceJour', hint: '' },
    { object: 'VendInvoiceTrans', hint: '' },
    { object: 'VendTrans', hint: '' },
    { object: 'LedgerJournalTable', hint: '' },
    { object: 'LedgerJournalTrans', hint: '' },
    { object: 'GeneralJournalEntry', hint: '' },
    { object: 'GeneralJournalAccountEntry', hint: '' },
    { object: 'MainAccount', hint: '' },
    { object: 'DimensionAttributeValueCombination', hint: '' },
    { object: 'InventDim', hint: '' },
    { object: 'InventTrans', hint: '' },
    { object: 'InventSum', hint: '' },
    { object: 'InventOnHand', hint: '' },
    { object: 'WHSInventReserve', hint: '' },
    { object: 'SalesQuotationTable', hint: '' },
    { object: 'SalesQuotationLine', hint: '' },
    { object: 'PurchReqTable', hint: '' },
    { object: 'PurchReqLine', hint: '' },
    { object: 'BankAccountTable', hint: '' },
    { object: 'BankAccountTrans', hint: '' },
    { object: 'CustPaymModeTable', hint: '' },
    { object: 'VendPaymModeTable', hint: '' },
    { object: 'ProjTable', hint: '' },
    { object: 'ProjTransPosting', hint: '' },
    { object: 'ProjInvoiceJour', hint: '' },
    { object: 'ProdTable', hint: '' },
    { object: 'ProdBOM', hint: '' },
    { object: 'BOMTable', hint: '' },
    { object: 'BOMVersion', hint: '' },
    { object: 'RouteTable', hint: '' },
    { object: 'InventLocation', hint: '' },
    { object: 'InventSite', hint: '' },
    { object: 'LogisticsPostalAddress', hint: '' },
    { object: 'HcmEmployment', hint: '' },
    { object: 'LedgerEntry', hint: '' },
    { object: 'TaxTrans', hint: '' },
    { object: 'CustGroup', hint: '' },
    { object: 'VendGroup', hint: '' },
    { object: 'InventItemGroup', hint: '' },
    { object: 'CompanyInfo', hint: '' },
    { object: 'CurrencyExchangeRate', hint: '' },
    { object: 'FiscalCalendar', hint: '' },
    { object: 'DimensionAttribute', hint: '' },
    { object: 'DimensionFinancialTag', hint: '' },
  ],
  'Vixxo': [
    { object: 'time', hint: 'Set ETA, Time In, or Time Out. Field Mappings: type (estimatedArrival, in, or out), serviceRequestNumber, time. For in/out also add latitude, longitude; for out also numberOfTechniciansOnSite and isJobComplete' },
    { object: 'incompletereason', hint: 'Only valid right after a Time Out with isJobComplete=false. Field Mappings: serviceRequestNumber, incompleteReasonType (awaitingParts, quoteRequired, or estimatedTimeOfReturn), hasTemporaryFix; add timestamp for estimatedTimeOfReturn' },
    { object: 'note', hint: 'Field Mappings: serviceRequestNumber, text, and optional type (VisitNote, RESOLUTION, or Note)' },
    { object: 'file', hint: 'Field Mappings: filename, file (base64), optional description. Not scoped to a service request — returns a key to use in the Attachment step' },
    { object: 'attachment', hint: 'Field Mappings: serviceRequestNumber, key (from the File Upload step), optional type=serviceRequest and subType (general, workTicket, or pmSurvey)' },
    { object: 'timeactivity', hint: 'Query action — Filter: serviceRequestNumber = <value>. Fields To Query is not honored; all fields are always returned' },
  ],
  // Add more systems here as needed
};

// Business Central aliases - all use the same objects
const businessCentralObjects = SYSTEM_OBJECT_SUGGESTIONS['Business Central'];
SYSTEM_OBJECT_SUGGESTIONS['BusinessCentral'] = businessCentralObjects;
SYSTEM_OBJECT_SUGGESTIONS['BusinessCentralAPI'] = businessCentralObjects;
SYSTEM_OBJECT_SUGGESTIONS['BusinessCentralOData'] = businessCentralObjects;
SYSTEM_OBJECT_SUGGESTIONS['BusinessCentralODatC'] = businessCentralObjects;

/**
 * Get system object suggestions for a given system
 * @param {string} system - The system/connector name
 * @returns {Array} Array of suggestion objects with 'object' and 'hint' properties
 */
export const getSystemObjectSuggestions = (system) => {
  if (!system) return [];

  // Try exact match first
  if (SYSTEM_OBJECT_SUGGESTIONS[system]) {
    return SYSTEM_OBJECT_SUGGESTIONS[system];
  }

  // Try case-insensitive match
  const systemLower = system.toLowerCase();
  for (const key of Object.keys(SYSTEM_OBJECT_SUGGESTIONS)) {
    if (key.toLowerCase() === systemLower) {
      return SYSTEM_OBJECT_SUGGESTIONS[key];
    }
  }

  // Try partial match (system contains or is contained in key)
  for (const key of Object.keys(SYSTEM_OBJECT_SUGGESTIONS)) {
    if (key.toLowerCase().includes(systemLower) || systemLower.includes(key.toLowerCase())) {
      return SYSTEM_OBJECT_SUGGESTIONS[key];
    }
  }

  return [];
};
